<template>
  <div class="expand-collapse-container">
    <div class="content-container">
      <p class="content" ref="content">{{ content }}</p>
    </div>
    <div class="button-container" v-if="showButton">
      <div class="btn" @click="handleStatusChange">{{ butttonLabel }}</div>
    </div>
  </div>
</template>

<script>

const EXPAND_STATUS = 'expand'
const COLLAPSE_STATUS = 'collapse'

export default {
  components: {
  },
  props: {
    content: {
      require: true
    },
    minDisplayLines: {
      default: 7
    }
  },
  data () {
    return {
      status: COLLAPSE_STATUS,
      contenLines: 0
    }
  },
  computed: {
    butttonLabel () {
      if (this.status === EXPAND_STATUS) {
        return this.$t('hm.btn.collapse')
      } else {
        return this.$t('hm.btn.expand')
      }
    },
    showButton () {
      if (!this.content || this.contenLines < this.minDisplayLines) {
        return false
      }
      return true
    }
  },
  created () {
    this.initContent()
  },
  beforeDestroy () {

  },
  methods: {
    initContent () {
      this.$nextTick(() => {
        this.contenLines = this.$refs.content.scrollHeight / 16
      })
      if (this.status === COLLAPSE_STATUS) {
        this.collapseContent()
      }
    },
    handleStatusChange () {
      if (this.status === EXPAND_STATUS) {
        this.collapseContent()
        this.status = COLLAPSE_STATUS
      } else {
        this.expandContent()
        this.status = EXPAND_STATUS
      }
    },
    collapseContent () {
      this.$nextTick(() => {
        if (this.contenLines > this.minDisplayLines) {
          this.$refs.content.style.height = 16 * this.minDisplayLines + 'px'
        }
      })
    },
    expandContent () {
      this.$nextTick(() => {
        this.$refs.content.style.height = 'auto'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.expand-collapse-container {
  .content-container {
    margin-bottom: 5px;

    .content {
      line-height: 16px;
      font-size: 15px;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .button-container {
    display: flex;
    font-size: 15px;
    justify-content: flex-end;
    color: #0096cc;
  }
}
</style>
